import { IUserTenant } from "../../../shared/context/auth-context";

export interface IUserData {
  active_status: boolean;
  admin: boolean;
  email: string;
  id: string;
  last_name: string;
  name: string;
  super_admin?: boolean;
  tenants: IUserTenant[];
}

export function transformFromBackendUser(backendType: IUserData) {
  return {
    ...backendType,
    tenants: backendType.tenants.map((tenant: IUserTenant) => {
      return {
        ...tenant,
        roles: tenant.roles.map((role: string) => {
          let result = role;
          if (role === "tenant_admin") {
            result = "Admin";
          } else if (role === "write") {
            result = "Write";
          } else if (role === "read") {
            result = "Read";
          }
          return result;
        }),
      };
    }),
  };
}
